import { atom } from "jotai";

export const isConfirmedBookingModalOpenAtom = atom(false);
